<template lang="html">
  <PlpShell :category="selectedCategory" />
</template>

<script setup lang="ts">
/**
 * Leaf (or R3 fallback) category PLP — thin page wrapper over shared PlpShell (Phase 7).
 * Listing scope: CatalogShowcase Filter.CategoryId = that category only (R20).
 */
import PlpShell from '#Products/components/Catalog/PlpShell.vue'
import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

defineProps<{
  selectedCategory?: CategoryDto
}>()
</script>
